import {getRequiredError, valid} from "./ValidationChecker";
import {handleActiveError, handleActiveToast} from "../sonner/ToastBasic";
import {closeDrawer} from "../../redux/slice/opnerSlice";

export function inputOnChange(f, t, v, required) {
    valid(required, t, v, f);
    setState(f, t, v);
}

export function inputOnKeyDown(f, u, id, t, v, e, required) {
    if (!!getRequiredError(required, v)) {
        alert("필수값 입니다.")
        return;
    }

    const singleUpdateDto = {
        id: id,
        value: v,
        fieldName: t,
    }
    getToastMessageByApi(u, singleUpdateDto,()=> setState(f, t, v));
}

function setState(f, t, v) {
    f((prev) => ({
        ...prev,
        [t]: v,
    }));
}

export function subInputOnChange(f, t, dto, v) {
    setSubState(f, dto, t, v);
}


export function subInputOnKeyDown(f, u, t, dto, v, e) {
    const singleUpdateDto = {
        id: dto.id,
        subId: dto.subId,
        value: v,
        fieldName: dto.fieldName,
    }
    getToastMessageByApi(u, singleUpdateDto, () => setSubStateForUpdate(f, dto, t, v))
}




function setSubStateForUpdate(f, dto, t, v) {

    f(prevState => {
        const newState = { ...prevState };
        const obj = {
            [dto.subName]:{id:dto.subId},
            [dto.fieldName]: v,
        };


        const targetArray = [...(newState[t] || [])];
        const existingIndex = targetArray.findIndex(
            item => item?.[dto.subName]?.id === dto.subId
        );
        console.log(existingIndex)
        if (existingIndex !== -1) {
            targetArray[existingIndex] = obj;
        } else {
            targetArray.push(obj);
        }
        // targetArray[dto.index] = obj;
        newState[t] = targetArray;
        console.log(newState);
        return newState;

    });
}



function setSubState(f, dto, t, v) {
    f(prevState => {
        const newState = { ...prevState };
        const obj = {
            [dto.subName]:{id:dto.subId},
            [dto.fieldName]: v,
        };
        const targetArray = [...(newState[t] || [])];

        targetArray[dto.index] = obj;
        newState[t] = targetArray;

        return newState;
    });
}


function getToastMessageByApi(u, updateObj, f) {
    u(updateObj).then(r => {
            if (r.status === 200) {
                handleActiveToast({
                    description: "", message: "수정 되었습니다.", labelListener: () => {
                    }
                })
                f();
            } else if (r.status === 201 || (r.status === 202)) {
                handleActiveError({message: r.data.title, description: r.data.reason});
            } else {
                handleActiveError({message: '처리실패', description: '알수 없는 원인'});
            }
        return false;
        }
    );
}



// 실사 공백등록을 위해서는 아래의 if문을 지우고, 백엔드의 requestBody의 require=false옵션을 줘야한다
export function diligenceAssetMessage(f, u, t, dto, v, e) {
    if(v!=='') {
        u(dto.id, dto.subId, v).then(r => {
            if (r.status === 200) {
                handleActiveToast({message: "저장 되었습니다."});
                f(prevState => {
                    const newState = [...prevState];
                    const targetArray = [...(newState || [])];
                    targetArray[dto.index] = v;
                    return targetArray;
                });
            } else if (r.status == 201 || r.status == 202) {
                handleActiveError({message: r.data.title, description: r.data.reason});
            }
        })
    }
}
